import { render, staticRenderFns } from "./custom_fields.vue?vue&type=template&id=60605aa0&"
import script from "./custom_fields.vue?vue&type=script&lang=js&"
export * from "./custom_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports